export const environment = {
  production: true,
  // eslint-disable-next-line @typescript-eslint/no-var-requires, @nx/enforce-module-boundaries
  appVersion: require('../../../package.json').version,
};
